import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserModel } from '../../@models';

@Injectable()
export class UserStateService {
  private userSubject = new BehaviorSubject<UserModel | null>(null);
  public user$ = this.userSubject.asObservable();

  setUser(user: UserModel | null): void {
    this.userSubject.next(user);
  }

  getUser(): UserModel | null {
    return this.userSubject.getValue();
  }
}